<template>
  <div id="app">
    <div id="nav">
      <img class="logo-stone-edge" src="./assets/stoneEdgeIco.png">
      <LocalSwitcher></LocalSwitcher>
       <div class="logout-item">
          <p id="app-version">V 1.0</p>
          <img
            @click="logoutUser"
            src="./assets/logout.svg"
            alt="logout"
            height="30px"/>
        </div>
    </div>
    <div class="router-view" :class="{'with-nav': displayNav}">
      <router-view/>
    </div>
    <div v-if="displayNav">
      <SidebarNav class="adjust-on-top"></SidebarNav>
    </div>
  </div>
</template>

<script>
import SidebarNav from '@/components/SidebarNav.vue'
import LocalSwitcher from '@/components/LocalSwitcher.vue'
import { AWSEventBus } from '@bag-era/cognito-authentication';

export default {
  components: {
    SidebarNav,
    LocalSwitcher
  },
  data() {
    return {
      displayNav: false,
    }
  },
  mounted() {
    console.log(this.$store.getters.cognitoUser);
    if (this.$store.getters.cognitoUser) {
      this.displayNav = true
    }
  },
  watch: {
    $route() {
       if (this.$store.getters.cognitoUser) {
          this.displayNav = true
        }
    },
  },
  methods: {
    isAuthenticated () {
      const authOK = this.$store.getters.cognitoUser != null;
      return authOK;
    },
    logoutUser () {
      AWSEventBus.$emit('loggedOut');
      this.displayNav = false;
    },
  }
}
</script>

<style>
:root { 
  --color1: #464B60;
  --color1light: #72778d;
  --color2: #009688;
  --colorText1: rgb(255, 255, 255);
  --login-main-bg-color: rgb(70, 75, 96, 0.3);
  --login-main-color: rgb(70, 75, 96);
}


body, html {
  margin: 0;
  background-color: rgb(235, 235, 235);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(42, 67, 116);
}
#nav {
  display: flex;
  padding: 10px;
  background-color: var(--color1);
  position: fixed;
  top: 0;
  left:0;
  width: 100%;
  z-index: 100;
  height: 25px;
}

#nav a {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.6);
}

#nav a.router-link-exact-active {
  color: rgba(255, 255, 255, 1);
}

h2 {
  color: var(--color1);
}

.main-container {
   width: 90%;
    max-width: 1600px;
    margin: auto;
}

.custom-margin {
  margin-bottom: 24px;
}

.el-card {
  border-radius: 12px !important;
}


.adjust-on-top {
  position: fixed;
  top:100px;
  left: 0;
  width: 250px;
  margin-top: -70px;
}

.router-view {
  /* position: absolute; */
  top: 50px;
  left: 270px;
  right: 0;
  padding: 20px;
}

.with-nav{
  position: absolute;
}

.light-text {
  color: grey;
  font-size: 12px;
}

.field-margin {
  margin-bottom: 20px;
}

.custom-breadcrumb {
  margin-bottom: 20px;
}

.el-table {
  border-radius: 12px;
}

.el-table--border::after, .el-table--group::after, .el-table::before {
  z-index: 0 !important;
}
.el-dialog {
  max-height: 80%;
  overflow-y: auto;
}

.logo-stone-edge {
  height: 50px;
  margin-top: -14px;
}

#app-version {
  color: #97a3d6;
  margin-right: 12px;
}

.logout-item {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 24px;
}

.logout-item > img:hover {
  cursor: pointer;
}

.el-input--mini .el-input__inner {
  border: white !important;
}
</style>
